
import {
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  ReservaService,
  ReservaResponse
} from '../../../service/reserva.service';

import Swal from 'sweetalert2';

import { FormsModule } from '@angular/forms';
import {
  AdminReservaService
} from '../../../service/admin-reserva.service';

@Component({
  selector: 'app-reservas',

  standalone: true,

  templateUrl: './reservas.component.html',

  styleUrls: [
    './reservas.component.css'
  ],

  imports: [
    CommonModule,
    FormsModule
  ]
})
export class ReservasComponent
  implements OnInit {


  reservas: ReservaResponse[] = [];

  carregando = false;

  cancelandoId: number | null = null;
  codigoCupom?: string | null;

  ordenacaoFiltro: 'RECENTES' | 'ANTIGAS' = 'RECENTES';


  modalEditarDatasAberto = false;
  reservaEmEdicao: ReservaResponse | null = null;

  novaDataCheckIn = '';
  novaDataCheckOut = '';

  salvandoDatasId: number | null = null;



  erro = '';

  statusFiltros = [
    {
      valor: 'TODOS',
      label: 'Todos os status'
    },
    {
      valor: 'AGUARDANDO_PAGAMENTO',
      label: 'Aguardando pagamento'
    },
    {
      valor: 'PAGA',
      label: 'Paga'
    },
    {
      valor: 'CONFIRMADA',
      label: 'Confirmada'
    },
    {
      valor: 'FINALIZADA',
      label: 'Finalizada'
    },
    {
      valor: 'CANCELADA',
      label: 'Cancelada'
    },
    {
      valor: 'EXPIRADA',
      label: 'Expirada'
    },
    {
      valor: 'REEMBOLSADA',
      label: 'Reembolsada'
    }
  ];

  statusFiltro: string = 'TODOS';

  reservasTodas: ReservaResponse[] = [];

  termoBusca: string = '';

  gerandoLinkId: number | null = null;


  constructor(
    private readonly reservaService: ReservaService,
    private readonly adminReservaService: AdminReservaService,
    private readonly cdr: ChangeDetectorRef
  ) {}


  ngOnInit(): void {

    this.carregarReservas();

  }

  async gerarLinkPagamento(
    reserva: ReservaResponse
  ): Promise<void> {

    if (
      reserva.status !== 'AGUARDANDO_PAGAMENTO' ||
      this.obterInvoiceUrl(reserva) ||
      this.gerandoLinkId !== null
    ) {
      return;
    }

    const resultado = await Swal.fire({
      icon: 'question',
      title: 'Gerar link de pagamento?',
      html: `
      <div style="text-align:left;font-size:14px">
        <p>
          Deseja gerar um link de pagamento para
          a <strong>reserva #${reserva.id}</strong>?
        </p>

        <p>
          <strong>Valor da reserva:</strong><br>
          ${this.formatarMoeda(reserva.valorTotal)}
        </p>

        <p style="color:#64748b;font-size:13px">
          O link será gerado utilizando os dados e
          o valor já registrados na reserva.
        </p>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: 'Sim, gerar link',
      cancelButtonText: 'Voltar',
      confirmButtonColor: '#173b63',
      cancelButtonColor: '#777',
      reverseButtons: true
    });

    if (!resultado.isConfirmed) {
      return;
    }

    this.gerandoLinkId = reserva.id;
    this.cdr.detectChanges();

    Swal.fire({
      title: 'Gerando link...',
      text: 'Aguarde enquanto o link é criado no Asaas.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    this.adminReservaService
      .gerarLinkPagamento(reserva.id)
      .subscribe({

        next: (response) => {

          this.gerandoLinkId = null;

          // Atualiza a reserva sem perder os filtros atuais
          this.reservasTodas = this.reservasTodas.map(r =>
            r.id === reserva.id
              ? { ...r, invoiceUrl: response.invoiceUrl }
              : r
          );

          this.aplicarFiltroStatus();
          this.cdr.detectChanges();

          Swal.fire({
            icon: 'success',
            title: 'Link gerado com sucesso!',
            text: `O link de pagamento da reserva #${reserva.id} está disponível.`,
            confirmButtonText: 'OK',
            confirmButtonColor: '#173b63'
          });
        },

        error: (erro) => {

          this.gerandoLinkId = null;
          this.cdr.detectChanges();

          Swal.fire({
            icon: 'error',
            title: 'Erro ao gerar link',
            text:
              erro?.error?.message ||
              erro?.error?.mensagem ||
              'Não foi possível gerar o link de pagamento.',
            confirmButtonText: 'Entendi',
            confirmButtonColor: '#173b63'
          });
        }
      });
  }


  podeEditarDatas(reserva: ReservaResponse): boolean {
    return ![
      'CANCELADA',
      'EXPIRADA',
      'REEMBOLSADA',
      'FINALIZADA'
    ].includes(reserva.status);
  }

  abrirModalEditarDatas(reserva: ReservaResponse): void {
    if (!this.podeEditarDatas(reserva)) {
      return;
    }

    this.reservaEmEdicao = reserva;
    this.novaDataCheckIn = reserva.checkIn;
    this.novaDataCheckOut = reserva.checkOut;

    this.modalEditarDatasAberto = true;
    this.cdr.detectChanges();
  }

  fecharModalEditarDatas(): void {
    if (this.salvandoDatasId !== null) {
      return;
    }

    this.modalEditarDatasAberto = false;
    this.reservaEmEdicao = null;
    this.novaDataCheckIn = '';
    this.novaDataCheckOut = '';

    this.cdr.detectChanges();
  }

  async confirmarEdicaoDatas(): Promise<void> {
    const reserva = this.reservaEmEdicao;

    if (!reserva || this.salvandoDatasId !== null) {
      return;
    }

    const checkIn = this.novaDataCheckIn;
    const checkOut = this.novaDataCheckOut;

    if (!checkIn || !checkOut) {
      await Swal.fire({
        icon: 'warning',
        title: 'Datas obrigatórias',
        text: 'Informe o check-in e o check-out.',
        confirmButtonColor: '#173b63'
      });
      return;
    }

    if (checkOut <= checkIn) {
      await Swal.fire({
        icon: 'warning',
        title: 'Período inválido',
        text: 'O check-out deve ser posterior ao check-in.',
        confirmButtonColor: '#173b63'
      });
      return;
    }

    if (
      checkIn === reserva.checkIn &&
      checkOut === reserva.checkOut
    ) {
      await Swal.fire({
        icon: 'info',
        title: 'Nenhuma alteração',
        text: 'As datas informadas são iguais às datas atuais.',
        confirmButtonColor: '#173b63'
      });
      return;
    }

    const resultado = await Swal.fire({
      icon: 'question',
      title: 'Confirmar alteração de datas?',
      html: `
      <div style="text-align:left;font-size:14px">
        <p>Deseja realmente alterar as datas da
        <strong>reserva #${reserva.id}</strong>?</p>

        <p><strong>Período atual</strong><br>
          ${this.formatarData(reserva.checkIn)}
          até ${this.formatarData(reserva.checkOut)}
        </p>

        <p><strong>Novo período</strong><br>
          ${this.formatarData(checkIn)}
          até ${this.formatarData(checkOut)}
        </p>

        <p style="color:#64748b;font-size:13px">
          O valor, o status e os dados de pagamento
          permanecerão inalterados.
        </p>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: 'Sim, alterar datas',
      cancelButtonText: 'Voltar',
      confirmButtonColor: '#173b63',
      cancelButtonColor: '#777',
      reverseButtons: true
    });

    if (!resultado.isConfirmed) {
      return;
    }

    this.salvandoDatasId = reserva.id;
    this.cdr.detectChanges();

    Swal.fire({
      title: 'Salvando alterações...',
      text: 'Validando a disponibilidade das novas datas.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    this.reservaService.editarDatas(
      reserva.id,
      { checkIn, checkOut }
    ).subscribe({
      next: (atualizada) => {
        this.reservasTodas = this.reservasTodas.map(r =>
          r.id === reserva.id ? atualizada : r
        );

        this.aplicarFiltroStatus();

        this.salvandoDatasId = null;
        this.modalEditarDatasAberto = false;
        this.reservaEmEdicao = null;
        this.novaDataCheckIn = '';
        this.novaDataCheckOut = '';

        this.cdr.detectChanges();

        Swal.fire({
          icon: 'success',
          title: 'Datas atualizadas!',
          text: `As datas da reserva #${reserva.id} foram alteradas com sucesso.`,
          confirmButtonText: 'OK',
          confirmButtonColor: '#173b63'
        });
      },

      error: (erro) => {
        this.salvandoDatasId = null;
        this.cdr.detectChanges();

        Swal.fire({
          icon: 'error',
          title: 'Não foi possível alterar as datas',
          text: this.obterMensagemErroDatas(erro),
          confirmButtonText: 'Entendi',
          confirmButtonColor: '#173b63'
        });
      }
    });
  }

  private obterMensagemErroDatas(erro: any): string {
    if (typeof erro?.error?.message === 'string') {
      return erro.error.message;
    }

    if (typeof erro?.error?.mensagem === 'string') {
      return erro.error.mensagem;
    }

    if (typeof erro?.error === 'string') {
      return erro.error;
    }

    return 'Não foi possível salvar as novas datas. Verifique a disponibilidade e tente novamente.';
  }


  buscarReservas(): void {

    const termo = this.termoBusca.trim();

    if (!termo) {
      Swal.fire({
        icon: 'warning',
        title: 'Informe uma busca',
        text: 'Digite o número da reserva, CPF ou nome do hóspede.',
        confirmButtonText: 'Entendi'
      });

      return;
    }

    this.carregando = true;
    this.erro = '';

    Swal.fire({
      title: 'Buscando reservas...',
      text: 'Aguarde um momento.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.reservaService.buscarReservas(termo).subscribe({

      next: (reservas) => {

        this.reservasTodas = reservas;

        this.aplicarFiltroStatus();

        this.carregando = false;

        this.cdr.detectChanges();

        Swal.close();

        this.cdr.detectChanges();

        if (reservas.length === 0) {

          Swal.fire({
            icon: 'info',
            title: 'Nenhuma reserva encontrada',
            text: `Não encontramos nenhuma reserva para "${termo}".`,
            confirmButtonText: 'Entendi'
          });

        }

      },

      error: (erro) => {

        this.carregando = false;

        Swal.close();

        Swal.fire({
          icon: 'error',
          title: 'Erro ao buscar reservas',
          text: 'Não foi possível realizar a busca. Tente novamente.',
          confirmButtonText: 'Fechar'
        });

      }

    });
  }

  obterInvoiceUrl(reserva: ReservaResponse): string | null {
    const url = reserva.invoiceUrl;

    if (typeof url !== 'string' || !url.trim()) {
      return null;
    }

    try {
      const parsedUrl = new URL(url.trim());

      return parsedUrl.protocol === 'https:'
        ? parsedUrl.toString()
        : null;

    } catch {
      return null;
    }
  }

  abrirInvoice(reserva: any): void {
    const url = this.obterInvoiceUrl(reserva);

    if (!url) {
      return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  }


  limparBusca(): void {

    this.termoBusca = '';

    this.statusFiltro = 'TODOS';

    this.ordenacaoFiltro = 'RECENTES';

    this.carregarReservas();

  }



  alterarOrdenacao(): void {

    this.aplicarFiltroStatus();

    this.cdr.detectChanges();

  }



  aplicarFiltroStatus(): void {

    // Filtrar por status
    let resultado = [...this.reservasTodas];

    if (this.statusFiltro !== 'TODOS') {
      resultado = resultado.filter(
        reserva => reserva.status === this.statusFiltro
      );
    }

    // Ordenar pelo ID da reserva
    resultado.sort((a, b) => {

      if (this.ordenacaoFiltro === 'RECENTES') {
        return b.id - a.id;
      }

      return a.id - b.id;

    });

    this.reservas = resultado;

  }


  alterarFiltroStatus(): void {

    this.aplicarFiltroStatus();

    this.cdr.detectChanges();

  }

  getTelefonePrincipal(
    reserva: ReservaResponse
  ): string {

    if (
      !reserva.hospedes
      || reserva.hospedes.length === 0
    ) {

      return '-';

    }

    const telefone =
      reserva.hospedes[0]?.telefone;

    if (!telefone) {

      return '-';

    }

    return this.formatarTelefone(telefone);

  }

  formatarTelefone(
    telefone: string
  ): string {

    if (!telefone) {

      return '-';

    }

    const numeros =
      telefone.replace(/\D/g, '');

    // Brasil com DDD
    if (numeros.length === 11) {

      return numeros.replace(
        /^(\d{2})(\d{5})(\d{4})$/,
        '($1) $2-$3'
      );

    }

    // Brasil com código do país
    if (numeros.length === 13 && numeros.startsWith('55')) {

      return numeros.replace(
        /^55(\d{2})(\d{5})(\d{4})$/,
        '+55 ($1) $2-$3'
      );

    }

    return telefone;

  }

  carregarReservas(): void {

    this.carregando = true;

    this.erro = '';


    this.reservaService
      .listar()
      .subscribe({

        next: (reservas) => {

          this.reservasTodas = reservas;

          this.aplicarFiltroStatus();

          this.carregando = false;

          this.cdr.detectChanges();

        },


        error: (erro) => {

          this.erro =
            'Não foi possível carregar as reservas.';

          this.carregando = false;

          this.cdr.detectChanges();

          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível carregar as reservas.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#173b63'
          });

        }

      });

  }

  cancelarReserva(
    reserva: ReservaResponse
  ): void {

    if (
      reserva.status === 'CANCELADA'
    ) {

      return;

    }

    Swal.fire({

      icon: 'warning',

      title: 'Cancelar reserva?',

      html: `
      <div style="
        text-align: left;
        margin-top: 20px;
        font-size: 15px;
        border-radius: 12px;
      ">

        <p style="
          text-align: center;
          margin-bottom: 20px;
          color: #555;
        ">
          Deseja realmente cancelar a reserva
          <strong>#${reserva.id}</strong>?
        </p>

        <div style="
          background: #f8f9fa;
          border-radius: 12px;
          padding: 16px;
          border: 1px solid #e9ecef;
        ">

          <div style="
            margin-bottom: 10px;
          ">
            <span style="color: #777;">
              🏡 Quarto
            </span>

            <strong style="
              display: block;
              margin-top: 3px;
              color: #222;
            ">
              ${reserva.quartoNome}
            </strong>
          </div>

          <div style="
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 12px;
          ">

            <div>
              <span style="color: #777;">
                📅 Check-in
              </span>

              <strong style="
                display: block;
                margin-top: 3px;
                color: #222;
              ">
                ${this.formatarData(reserva.checkIn)}
              </strong>
            </div>

            <div>
              <span style="color: #777;">
                📅 Check-out
              </span>

              <strong style="
                display: block;
                margin-top: 3px;
                color: #222;
              ">
                ${this.formatarData(reserva.checkOut)}
              </strong>
            </div>

          </div>

          <div style="
            margin-top: 14px;
            padding-top: 14px;
            border-top: 1px solid #e5e5e5;
          ">

            <span style="color: #777;">
              💰 Valor total
            </span>

            <strong style="
              display: block;
              margin-top: 3px;
              font-size: 18px;
              color: #198754;
            ">
              ${this.formatarMoeda(reserva.valorTotal)}
            </strong>

          </div>

        </div>

        <div style="
          margin-top: 16px;
          padding: 12px;
          border-radius: 10px;
          background: #fff8e1;
          border: 1px solid #ffe082;
          color: #795548;
          font-size: 13px;
        ">
          ⚠️ O pagamento será reembolsado ao cliente.
        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: 'Sim, cancelar',

      cancelButtonText: 'Voltar',

      confirmButtonColor: '#a85a5a',

      cancelButtonColor: '#777',

      reverseButtons: true

    }).then((resultado) => {

      if (!resultado.isConfirmed) {

        return;

      }


      this.executarCancelamento(reserva);

    });

  }

  private executarCancelamento(
    reserva: ReservaResponse
  ): void {

    this.cancelandoId =
      reserva.id;


    this.reservaService
      .cancelar(reserva.id)
      .subscribe({

        next: (reservaCancelada) => {

          const index =
            this.reservas.findIndex(
              r => r.id === reserva.id
            );


          if (index !== -1) {

            if (reservaCancelada) {

              this.reservas[index] =
                reservaCancelada;

            } else {

              this.reservas[index] = {

                ...this.reservas[index],

                status: 'CANCELADA'

              };

            }

          }


          this.cancelandoId = null;

          this.cdr.detectChanges();

          Swal.fire({

            icon: 'success',

            title: 'Reserva cancelada',

            text:
              'A reserva foi cancelada e o reembolso foi solicitado com sucesso.',

            confirmButtonText: 'OK',

            confirmButtonColor: '#173b63'

          });

        },


        error: (erro) => {

          this.cancelandoId = null;

          let mensagem =
            'Não foi possível cancelar a reserva.';

          if (
            erro?.error?.message
          ) {

            mensagem =
              erro.error.message;

          }
          else if (
            typeof erro?.error === 'string'
          ) {

            mensagem =
              erro.error;

          }


          this.cdr.detectChanges();

          Swal.fire({

            icon: 'error',

            title: 'Não foi possível cancelar',

            text: mensagem,

            confirmButtonText: 'OK',

            confirmButtonColor: '#173b63'

          });

        }

      });

  }

  podeCancelar(
    reserva: ReservaResponse
  ): boolean {

    if (
      reserva.status !== 'PAGA'
      &&
      reserva.status !== 'CONFIRMADA'
    ) {

      return false;

    }

    const hoje =
      new Date();


    const checkIn =
      new Date(
        reserva.checkIn + 'T00:00:00'
      );

    const diferenca =
      checkIn.getTime()
      -
      hoje.getTime();


    const dias =
      diferenca /
      (1000 * 60 * 60 * 24);


    return dias >= 7;

  }

  formatarData(
    data: string
  ): string {

    if (!data) {

      return '-';

    }

    const [
      ano,
      mes,
      dia
    ] =
      data.split('-');


    return `${dia}/${mes}/${ano}`;

  }

  formatarMoeda(
    valor: number
  ): string {

    return valor.toLocaleString(
      'pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }
    );

  }

  getStatusLabel(
    status: string
  ): string {

    switch (status) {

      case 'CONFIRMADA':
        return 'Confirmada';

      case 'PAGA':
        return 'Paga';

      case 'AGUARDANDO_PAGAMENTO':
        return 'Aguardando pagamento';

      case 'CANCELADA':
        return 'Cancelada';

      case 'EXPIRADA':
        return 'Expirada';

      case 'FINALIZADA':
        return 'Finalizada';

      default:
        return status;

    }

  }

}
